import React from 'react'
import VehicleSheetDocuments from '../VehicleSheetDocuments/VehicleSheetDocuments'
import VehicleSheetEquipments from '../VehicleSheetEquipments/VehicleSheetEquipments'
import VehicleSheetSellerObservation from '../VehicleSheetSellerObservation'

const VehicleSheetSectionModelInfo = () => (
  <div className="vehicle-sheet__info-grid">
    <VehicleSheetEquipments />
    <VehicleSheetSellerObservation />
    <section className="vehicle-sheet-card vehicle-sheet__documents">
      <h2 className="vehicle-sheet__subsection-title">Documents</h2>
      <VehicleSheetDocuments />
    </section>
  </div>
)

export default VehicleSheetSectionModelInfo
